import { Box, Flex, Link, Text } from '@chakra-ui/react';

import type { GlobalAssistantAccessDecision } from './global-ai-assistant-access';
import styles from './global-ai-assistant-permission-upsell.module.css';

const SALES_EMAIL = 'sales@reveliolabs.com';
const SALES_MAILTO = `mailto:${SALES_EMAIL}?subject=Dashboard%20access`;

type DeniedAccess = Exclude<GlobalAssistantAccessDecision, { allowed: true }>;

export function GlobalAssistantPermissionUpsell({
  access,
  'data-testid': dataTestId,
}: {
  access: DeniedAccess;
  'data-testid'?: string;
}) {
  return (
    <Flex
      alignSelf="stretch"
      align="flex-start"
      gap={2}
      maxW="100%"
      data-testid={dataTestId}
    >
      <Box flex={1} minW={0}>
        <Text fontSize="12px" lineHeight="15px" className={styles.text}>
          {access.message}{' '}
          <Link
            href={SALES_MAILTO}
            variant="tooltip"
            fontSize="12px"
            lineHeight="15px"
            data-testid="global-ai-permission-upsell-email-sales"
          >
            {SALES_EMAIL}
          </Link>
        </Text>
      </Box>
    </Flex>
  );
}
